import Backbone from 'backbone'
import template from './reports-wizard-header.hbs'

var Header = Backbone.View.extend({

	tagName: 'header',

	className: 'dialog-header table-hack-row',

	initialize: function() {
		this.listenTo(this.model, 'change:index', this.render)
	},

	render: function() {
		this.$el.html(template(this.model.currentStep()))
		return this
	}

})

export default Header

Header.__filename__ = 'reports/wizard/reports-wizard-header.js'
